export function generateScriptString(data: string): string {
    return `<script type="application/ld+json">${data}</script>`;
};
